<template>
  <div>
    <div
      class="choice"
      @click="selectInput()"
      :class="selected ? 'selected' : ''"
    >
      <div class="columns is-gapless is-multiline is-mobile is-vcentered">
        <div class="column is-narrow" style="padding-right: 20px !important;">
          <transition name="slideb" mode="out-in">
            <span class="icon is-medium" v-if="!selected" key="unchecked">
              <i class="far fa-2x fa-circle" style="color: grey;"></i>
            </span>
            <span class="icon is-medium" v-if="selected" key="checked">
              <i class="far fa-2x fa-check-circle" style="color: #1a689b;"></i>
            </span>
          </transition>
        </div>
        <div class="column">
          <p style="font-size: 0.85rem;"><slot></slot></p>
        </div>
      </div>
    </div>
    <p class="help is-danger" style="margin-bottom: 20px;" v-if="field.error">{{ field.error }}</p>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  model() {
    return { value: "", error: "", typed: false };
  },
  props: {
    inputField: Object,
    inputName: String,
    inputType: String
  },
  data() {
    return {
      field: this.inputField,
      selected: false
    };
  },
  methods: {
    modified() {
      this.field.typed = true;
      this.setValue(this.selected)
      this.validate();
    },
    validate() {
      console.log("validating");
      this.field.error = null;
      if (!this.field.value && this.inputType == "required") {
        this.field.error = "You must agree to our policies to continue.";
      }
      console.log(this.field.error);
      return this.field.error == null;
    },
    setValue(s) {
      this.field.value = s;
      // this.modified();
    },
    selectInput() {
      this.selected = !this.selected;
      this.modified();
      this.validate();
    }
  }
};
</script>
<style scoped>
.field {
  padding: 20px 20px;
  background: #edf0f3;
  border-radius: 5px;
  margin: 12px 0px;
}
.choice {
  padding: 15px;
  transition: all 0.5s;
  margin: 20px 0px !important;
  cursor: pointer;
  border: 1px solid #1a689b;
  border-radius: 5px;
}
.selected {
  background: #f0f4ff;
}
</style>
